import React from 'react';
import '../../App.css';
import './CookiesPage.css';

function CookiesPage() {
  return (
    <div className="page info-page cookies-page">
      <div className="info-columns">
        <div className="info-column">
          <h2>Cookie Policy</h2>
          <p><strong>Cookie Policy</strong></p>
          <p>This page explains how we use cookies on our website.</p>
          
          <h3>What are cookies?</h3>
          <p>Cookies are small text files that are stored on your device when you visit a website. They help us improve your experience and understand how our website is used.</p>

          <h3>What cookies do we use?</h3>
          <ul>
            <li><strong>Necessary cookies:</strong> Essential for the website to function properly (e.g., shopping cart, login sessions)</li>
            <li><strong>Analytical cookies:</strong> Help us understand how visitors use our website (e.g., Google Analytics)</li>
            <li><strong>Functional cookies:</strong> Remember your preferences and settings</li>
          </ul>

          <h3>Why do we use cookies?</h3>
          <ul>
            <li>To keep you logged in</li>
            <li>To remember items in your shopping cart</li>
            <li>To analyze website traffic and improve user experience</li>
            <li>To remember your language and region preferences</li>
          </ul>

          <h3>How to manage cookies</h3>
          <p>You can control and/or delete cookies through your browser settings. Please note that disabling certain cookies may affect the functionality of our website.</p>
          <p>For more information about managing cookies in different browsers:</p>
          <ul>
            <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">Chrome</a></li>
            <li><a href="https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer" target="_blank" rel="noopener noreferrer">Firefox</a></li>
            <li><a href="https://support.apple.com/guide/safari/manage-cookies-sfri11471/mac" target="_blank" rel="noopener noreferrer">Safari</a></li>
            <li><a href="https://support.microsoft.com/en-us/microsoft-edge/delete-cookies-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer">Edge</a></li>
          </ul>

          <h3>Questions?</h3>
          <p>If you have any questions about our use of cookies, please contact us at <a href="mailto:admin@ideafarm.se">admin@ideafarm.se</a>.</p>
        </div>
        <div className="info-column">
          <h2>Cookiepolicy</h2>
          <p><strong>Cookiepolicy</strong></p>
          <p>Den här sidan förklarar hur vi använder cookies på vår webbplats.</p>

          <h3>Vad är cookies?</h3>
          <p>Cookies är små textfiler som sparas på din enhet när du besöker en webbplats. De hjälper oss att förbättra din upplevelse och förstå hur vår webbplats används.</p>

          <h3>Vilka cookies använder vi?</h3>
          <ul>
            <li><strong>Nödvändiga cookies:</strong> Nödvändiga för att webbplatsen ska fungera korrekt (t.ex. kundvagn, inloggningssessioner)</li>
            <li><strong>Analytiska cookies:</strong> Hjälper oss förstå hur besökare använder vår webbplats (t.ex. Google Analytics)</li>
            <li><strong>Funktionella cookies:</strong> Kommer ihåg dina preferenser och inställningar</li>
          </ul>

          <h3>Varför använder vi cookies?</h3>
          <ul>
            <li>För att hålla dig inloggad</li>
            <li>För att komma ihåg varor i din kundvagn</li>
            <li>För att analysera webbplatstrafik och förbättra användarupplevelsen</li>
            <li>För att komma ihåg dina språk- och regionpreferenser</li>
          </ul>

          <h3>Hur hanterar man cookies</h3>
          <p>Du kan kontrollera och/eller ta bort cookies genom din webbläsares inställningar. Observera att inaktivering av vissa cookies kan påverka funktionaliteten på vår webbplats.</p>
          <p>För mer information om att hantera cookies i olika webbläsare:</p>
          <ul>
            <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">Chrome</a></li>
            <li><a href="https://support.mozilla.org/sv-SE/kb/cookies" target="_blank" rel="noopener noreferrer">Firefox</a></li>
            <li><a href="https://support.apple.com/sv-se/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer">Safari</a></li>
            <li><a href="https://support.microsoft.com/sv-se/microsoft-edge/ta-bort-cookies-i-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer">Edge</a></li>
          </ul>

          <h3>Frågor?</h3>
          <p>Om du har några frågor om vår användning av cookies, vänligen kontakta oss på <a href="mailto:admin@ideafarm.se">admin@ideafarm.se</a>.</p>
        </div>
      </div>
    </div>
  );
}

export default CookiesPage;
